import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=e6d191ac&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=e6d191ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d191ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6d191ac')) {
      api.createRecord('e6d191ac', component.options)
    } else {
      api.reload('e6d191ac', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=e6d191ac&scoped=true&", function () {
      api.rerender('e6d191ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nTdhpmRekKGS/JS/comp/CookieBox.vue"
export default component.exports